import React, {Fragment} from 'react';
import classnames from 'classnames';

const TextRenderer = ({data = {}, payload = {}, style = {customClasses: []}}) => {
  const isPayload = !!Object.keys(payload).length;

  const renderRow = (obj: any) => {
    const {order} = obj || {}; // Handle case where `order` might be undefined
    return (order as string[])?.map?.(item => {
      const dataItem = obj?.[item]; // Fetch each item using `item`
      const parsedText = dataItem?.primaryText;

      return (
        <span key={item} className={classnames(dataItem?.style?.customClasses)}>
          {parsedText || ''}
          {dataItem?.order && renderRow(dataItem)} {/* Recursive rendering for nested rows */}
        </span>
      );
    });
  };

  if (!data) return null;

  const children = (
    <Fragment>
      {Array.isArray(data)
        ? data.map((item: any, index: number) => (
            <p key={index} className={classnames(item?.style?.customClasses)}>
              {renderRow(item)}
            </p>
          ))
        : renderRow(data)}
    </Fragment>
  );

  return <div className={classnames(style.customClasses)}>{children}</div>;
};

export default TextRenderer;
